<template>
  <label class="oc-radio">
    <div v-if="innerChecked" class="oc-radio__icon-wrapper">
      <RadioButtonChecked class="oc-radio__icon" />
    </div>
    <div v-if="!innerChecked" class="oc-radio__icon-wrapper">
      <RadioButtonUnchecked class="oc-radio__icon" />
    </div>
    <input type="radio" :checked="innerChecked" @change="onChange" />
    <slot />
  </label>
</template>

<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api';
import RadioButtonChecked from 'images/radio_button_checked.svg';
import RadioButtonUnchecked from 'images/radio_button_unchecked.svg';

export default defineComponent({
  name: 'OCRadio',
  components: {
    RadioButtonChecked,
    RadioButtonUnchecked,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    checkedValue: {
      type: String,
      default: undefined,
    },
  },
  emits: {
    // NOTE: Vue3 になったら :checked-value.sync を v-model:checkedValue に書き換える想定
    'update:checkedValue': (_: string) => true,
  },
  setup(props, { emit }) {
    const innerChecked = computed({
      get() {
        return props.checkedValue === props.value;
      },
      set(newValue: boolean) {
        if (newValue) {
          emit('update:checkedValue', props.value);
        }
      },
    });
    const onChange = (e: Event) => {
      innerChecked.value = (e.target as HTMLInputElement).checked;
    }
    return {
      innerChecked,
      onChange,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.oc-radio {
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;

  input[type='radio'] {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}

.oc-radio__icon-wrapper {
  width: 15px;
  height: 15px;
  flex: none;
}

.oc-radio__icon {
  color: $oc-primary;
}
</style>
